import { UseQueryResult, useQuery } from "@tanstack/react-query";
import { getProductsBelongCategory } from "../apis/product";
import { CategorySlugContext } from "../context";
import { useContext } from "react";
import { IProductCategory } from "../models/category";

const useProductCategory = (
  page = 1,
  sort = "createdAt"
): UseQueryResult<IProductCategory> => {
  const slug = useContext(CategorySlugContext);

  const data = useQuery(
    ["ProductsByCategory", { page, slug, sort }],
    () => getProductsBelongCategory(page, slug, sort),
    {
      keepPreviousData: true,
    }
  );

  return data;
};

export default useProductCategory;
